import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/session/')({
  beforeLoad() {
    // セッション規定は未提供のため、旧 URL は SSO 設定へ寄せる。
    throw redirect({
      to: '/settings/authentication/settings/sso'
    });
  }
});